/*
 * @Descripttion:
 * @Author: 苍狼一啸八荒惊
 * @Date: 2024-08-29 17:34:57
 * @LastEditTime: 2025-07-16 15:22:43
 * @LastEditors: sudo_rm_rf
 */
import useCommonStore from './modules/common';
import useCounterStore from './modules/counter';

export * from './modules/setting';
export * from './modules/user';
export * from './modules/permission';
export * from './modules/webSocket';
export * from './modules/editor';

// export default function useStore() {
export function useStore() {
  return {
    piniaCommon: useCommonStore(),
    counter: useCounterStore(),
  };
}
